<template>
  <div class="pageContol testpaperList listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">我的资源</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">我的试卷/题库</a>
        </span>
      </div>
      <div class="framePage-body">
          <el-tabs v-model="activeName" :before-leave="beforeTabLeave">
            <el-tab-pane label="我的试卷" name="first">
               <MyPaper ref="first" />
            </el-tab-pane>
            <!-- <el-tab-pane label="我的题库" name="second">
               <myQuestionBank ref="second" />
            </el-tab-pane> -->
          </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import List from "@/mixins/List";
import { mapGetters } from "vuex";
import { resetKeepAlive } from "@/utils/common";
import MyPaper from "@/views/resourse/myPaperQuestionList/myPaper.vue";
// import myQuestionBank from "@/views/resourse/myPaperQuestionList/myQuestionBank.vue";
export default {
  name: "testPaperList",
  components: {
    MyPaper,
    // myQuestionBank,
  },
  mixins: [List],
  data() {
    return {
      activeName: "first"
    };
  },
   methods: {
    init() {
      const query = this.$route.query;
      if (query.active) {
        this.activeName = query.active;
      } else {
        this.activeName = "first";
      }
    },
    tabChange(tab) {
      this.$refs[tab.name].queryStr = "";
      this.$refs[tab.name].getData();
    },
    beforeTabLeave(newName) {
      this.$router.replace({
        path: this.$route.path,
        query: { active: newName }
      });
    }
  },
  beforeRouteLeave: resetKeepAlive,
  watch: {
    $route: function(route) {
      if(route.name !='testPaperList') return;
      if (route.params.refresh) {
        if (route.params.isAdd) {
          this.$refs[route.params.refName].cancleForm();
          this.$refs[route.params.refName].getData();
        } else {
          this.$refs[route.params.refName].getData(-1);
        }
      } else if(sessionStorage.getItem('refresh') !=0){
        sessionStorage.setItem('refresh',0);
        this.$refs['first'].cancleForm();
        this.$refs['first'].getData();
      }
    }
  }
};
</script>
<style lang="less" >
.testpaperList {
  .el-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    .el-tabs__content {
      flex: 1;
    }
  }
}
.searchbox {
  padding: 0;
}
.operationControlTest {
  > div {
    width: 100%;
    justify-content: space-between;
  }
  .el-form {
    display: flex;
    .el-form-item__label {
      padding: 0 8px 0 0 !important;
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .btns {
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
}
</style>
